import React from "react";
import { useLocation } from "react-router-dom";
import { Apple, Download, Star } from "lucide-react";
import image from "../Images/Login-left.png";
export default function DownloadApp() {
  const { pathname } = useLocation();
  const isAboutPage = pathname === "/about";
  return (
    <section className="w-full bg-blue-50 px-4 py-4 md:px-8 md:py-8">
      {" "}
      <div className="relative mx-auto w-full max-w-[1250px] overflow-hidden rounded-[20px] border border-[#dfe4ea] bg-gradient-to-r from-[#1A1349] via-[#242D69] to-[#3C5E9B]">
        <div className="flex flex-col md:flex-row">
          {" "}
          {/* Left content */}{" "}
          <div className="relative z-10 flex w-full flex-col justify-center px-7 pt-8 pb-0 sm:px-10 sm:pt-8 sm:pb-0 lg:min-h-[385px] lg:px-[47px] lg:pr-[42%] lg:py-8">
            {" "}
            <div>
              <span className="inline-flex h-[30px] items-center rounded-full bg-[#18b957] px-4 text-[12px] font-medium text-white sm:text-[13px]">
                {" "}
                {isAboutPage ? "About Chaafo" : "Download the app"}{" "}
              </span>{" "}
              <h2 className="mt-5 max-w-[540px] text-[27px] font-normal leading-[1.3] tracking-[-0.6px] text-white sm:text-[32px] lg:text-[35px]">
                {" "}
                {isAboutPage ? (
                  <>
                    {" "}
                    Bringing your neighbourhood{" "}
                    <br className="hidden sm:block" /> to your doorstep.{" "}
                  </>
                ) : (
                  <>
                    {" "}
                    Download our app for a <br className="hidden sm:block" />{" "}
                    faster ordering experience.{" "}
                  </>
                )}{" "}
              </h2>{" "}
              <p className="mt-2 max-w-[550px] text-[13px] leading-[19px] text-[#aebbd0] sm:text-[15px]">
                {" "}
                {isAboutPage ? (
                  <>
                    {" "}
                    Chaafo is a modern food ordering and local commerce platform
                    that connects customers with restaurants, grocery stores and
                    everyday essentials — with a premium app experience and the
                    simplicity of WhatsApp.{" "}
                  </>
                ) : (
                  <>
                    {" "}
                    Get exclusive in-app deals, real-time order tracking, and{" "}
                    <br className="hidden lg:block" /> a faster checkout. Join 4
                    million food lovers on Chaafo.{" "}
                  </>
                )}{" "}
              </p>{" "}
              {/* Rating */}{" "}
              <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-2">
                {" "}
                <div className="flex items-center gap-[3px]">
                  {" "}
                  {[1, 2, 3, 4].map((item) => (
                    <Star
                      key={item}
                      size={14}
                      fill="#fbbf24"
                      strokeWidth={0}
                      className="text-[#fbbf24]"
                    />
                  ))}{" "}
                  <div className="relative h-[14px] w-[14px] overflow-hidden">
                    {" "}
                    <Star
                      size={14}
                      strokeWidth={1.7}
                      className="absolute inset-0 text-[#d7deea]"
                    />{" "}
                    <div className="absolute inset-y-0 left-0 w-1/2 overflow-hidden">
                      {" "}
                      <Star
                        size={14}
                        fill="#fbbf24"
                        strokeWidth={0}
                        className="text-[#fbbf24]"
                      />{" "}
                    </div>{" "}
                  </div>{" "}
                  <span className="ml-1 text-[14px] text-[#aebbd0]">
                    4.5
                  </span>{" "}
                </div>{" "}
                <span className="text-[14px] text-[#aebbd0]">
                  {" "}
                  250K+ downloads{" "}
                </span>{" "}
              </div>{" "}
              {/* Store buttons */}{" "}
              <div className="mt-5 flex gap-2 sm:gap-3">
                {" "}
                {/* <a
                  href="#"
                  className="flex h-[48px] w-[160px] items-center gap-2 rounded-[8px] bg-white px-2.5 text-[#4f4f4f] transition hover:-translate-y-0.5 hover:shadow-lg sm:h-[56px] sm:w-[180px] sm:px-3"
                >
                  {" "}
                  <Apple
                    className="h-[18px] w-[18px] shrink-0 sm:h-6 sm:w-6"
                    strokeWidth={1.6}
                  />{" "}
                  <span className="text-left leading-none">
                    {" "}
                    <span className="block text-[9px] sm:text-[11px]">
                      {" "}
                      {isAboutPage ? "Order Now" : "Download on the"}{" "}
                    </span>{" "}
                    <span className="block text-[13px] font-medium sm:text-[16px]">
                      {" "}
                      {isAboutPage ? "Become a Partner" : "App Store"}{" "}
                    </span>{" "}
                  </span>{" "}
                </a> */}
                <div className="flex h-[48px] w-[160px] cursor-default items-center gap-2 rounded-[8px] bg-white px-2.5 text-[#4f4f4f] sm:h-[56px] sm:w-[180px] sm:px-3">
                  <Apple
                    className="h-[18px] w-[18px] shrink-0 sm:h-6 sm:w-6"
                    strokeWidth={1.6}
                  />

                  <span className="text-left leading-none">
                    <span className="block text-[9px] sm:text-[11px]">
                      {isAboutPage ? "Order Now" : "Download on the"}
                    </span>

                    <span className="block text-[13px] font-medium sm:text-[16px]">
                      {isAboutPage ? "Become a Partner" : "App Store"}
                    </span>
                  </span>
                </div>{" "}
                <a
                  href="https://play.google.com/store/apps/details?id=com.customer.chaafo"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex h-[48px] w-[160px] items-center gap-2 rounded-[8px] bg-white px-2.5 text-[#4f4f4f] transition hover:-translate-y-0.5 hover:shadow-lg sm:h-[56px] sm:w-[180px] sm:px-3"
                >
                  {" "}
                  <Download
                    className="h-[17px] w-[17px] shrink-0 sm:h-[21px] sm:w-[21px]"
                    strokeWidth={1.8}
                  />{" "}
                  <span className="text-left leading-none">
                    {" "}
                    <span className="block text-[9px] sm:text-[11px]">
                      {" "}
                      Get it on{" "}
                    </span>{" "}
                    <span className="block text-[13px] font-medium sm:text-[16px]">
                      {" "}
                      Google Play{" "}
                    </span>{" "}
                  </span>{" "}
                </a>{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
        <img
          src={image}
          alt="Chaafo food ordering app"
          className="relative mx-auto mt-8 h-[240px] w-auto object-contain opacity-95 sm:h-[280px] md:h-[355px] lg:absolute lg:bottom-0 lg:right-0 lg:mt-0 lg:h-[385px]"
        />
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-[#2a3f73] to-transparent" />{" "}
      </div>
    </section>
  );
}
